import { render, staticRenderFns } from "./CambioAsientoPasoPago.vue?vue&type=template&id=38118724"
import script from "./CambioAsientoPasoPago.vue?vue&type=script&setup=true&lang=js"
export * from "./CambioAsientoPasoPago.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports